class FacetDrawer extends MainDrawer {
  constructor() {
    super();

    this.trigger = this.querySelector('.drawer__trigger');
    if (this.trigger) {
      this.trigger.addEventListener('click', () => this.loadAssets());
    }
  }

  loadAssets() {
    if (!document.getElementById('FACETSCSS') && !document.getElementById('FACETSJS')) {
      this.classList.add('loading');
    }

    loadCss('facets')
      .then(() => {
        setTimeout(() => {
          this.classList.remove('loading');
        }, 300);
      })
      .catch((error) => {
        console.error(error);
      });
    loadScript('facets').catch((error) => {
      console.error(error);
    });
    this.openDrawer();
  }
}
customElements.define('facet-drawer', FacetDrawer);